import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../AppComponents/Games.scss";
import _ from "lodash";
import { reactLocalStorage } from "reactjs-localstorage";
import ConfirmPopup from "./ConfirmPop";
import config from "../config";

function Unsubscribe() {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showUnsubBtn, setShowUnsubBtn] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(false);
    const showUnSub = reactLocalStorage.get("showUnsub");
    
    setShowUnsubBtn(showUnSub);
  }, []);
 
  const handleCancelClick = () => {
    console.log("Cancel Subscription button clicked");
    setShowConfirmModal(true);
  };
  // function handleBtnClick() {
  //   let guiDataEvent = {};
  //   guiDataEvent["page"] = "unsubscription";
  //   guiDataEvent["event"] = "unsub_request";
  //   SendGuiDataEvents(guiDataEvent);
  //   setLoading(true);
  //   const url = `${config.get("base")}${config.get("unsubscribe")}`;
  //   fetch(url, {
  //     method: "POST",
  //     body: JSON.stringify({
  //       uid: reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "",
  //     }),
  //     headers: config.get("headers"),
  //   })
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw res;
  //       }
  //       return res.json();
  //     })
  //     .then(
  //       (result) => {
  //         console.log("result message::", result);
  //         logEventHome(
  //           {
  //             screen: screen.unsubPage,
  //             event: "unsub_api_success",
  //           },
  //           {
  //             status: result.status ? result.status : "NA",
  //             uid: reactLocalStorage.get("uid")
  //               ? reactLocalStorage.get("uid")
  //               : "NA",
  //           }
  //         );
  //         let guiDataEvents = {};
  //         guiDataEvents["page"] = "unsubscription";
  //         guiDataEvents["event"] = "unsub_response";
  //         guiDataEvents["status"] = result?.status;
  //         SendGuiDataEvents(guiDataEvents);
  //         reactLocalStorage.set(
  //           "show_un_sub",
  //           JSON.stringify(result.showUnsub)
  //         );
  //       },
  //       (error) => {
  //         console.log("error:::", error);
  //         setLoading(false);
  //       }
  //     );
  // }

  return (
    <>
      {loading ? (
        <div className="ld-bg">
          <div className="lds"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="container m-w">
              <div className="columns is-mobile">
                <div className="column is-full">
                  <div className="card">
                    <div className="card-content ">
                      <div className="display text-black">
                        <div className="text-start">
                          <h3 className="bold text-lg">Subscription Status</h3>
                          <h2 className="mt-4">
                            {reactLocalStorage.get("status_display")}
                          </h2>
                        </div>
                        <div className="text-start">
                          <h3 className="bold text-lg">Msisdn</h3>
                          <h2 className="mt-4">
                            {reactLocalStorage.get("msisdn")}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              className="cancel-btn text-white bold"
              onClick={handleCancelClick}
            >
              Annuler l'abonnement
            </button>
          </div>
        </>
      )}
      {showConfirmModal && (
        <ConfirmPopup
          cancelText={"cancel"}
          message="Are you sure you want to unsubscribe"
          showConfirmModal={showConfirmModal}
          setShowConfirmModal={setShowConfirmModal}
          loading={loading}
          setLoading={setLoading}
          // handleUnsub={handleBtnClick}
        />
      )}
    </>
  );
}
export default React.memo(Unsubscribe);
